window.axios = require("axios");

const productRecommendationsSection = document.querySelector('.product-recommendations');
const url = productRecommendationsSection.dataset.url;

function initYotpo() {
	if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
		window.yotpoWidgetsContainer.initWidgets();
	} else {
		setTimeout(initYotpo, 500);
	}
}

axios.get(url, {})
.then(function (response) {
	const text = response.data;
	const html = document.createElement('div');
	html.innerHTML = text;
	const recommendations = html.querySelector('.product-recommendations');
	if (recommendations && recommendations.innerHTML.trim().length) {
		productRecommendationsSection.innerHTML = recommendations.innerHTML;
		const swiper_recommended = new window.swiper('.recommendations-slider', {
			slidesPerView: 1.5,
			spaceBetween: 10,
			breakpoints: {
				768: {
					slidesPerView: 3
				},
				992: {
					slidesPerView: 4
				},
				1200: {
					slidesPerView: 5
				}
			},
			lazy: {
				enabled: true,
				checkInView: false,
				loadOnTransitionStart: true,
				loadPrevNext: true,
				loadPrevNextAmount: 1
			},
		});
		initYotpo();
	}
})
.catch(function (error) {
		window.log(error);
});